import React, { useEffect, useState } from "react"
import { Card, CardBody, Button, Table } from "reactstrap"
import { connect } from "react-redux"
import { Link, useParams, Redirect } from "react-router-dom"
import {formatAddress} from "../utils";

const TradingDetail = (props) => {
	const { id } = useParams()
	const { allTokens } = props
	const [selectedToken, setSelectedToken] = useState({})
	const [loading, isLoading] = useState(true)

	useEffect(() => {
		for (const token of allTokens) {
			if (id === token.token_id) {
				setSelectedToken(token)
				isLoading(false)
				break
			}
		}
	}, [id, allTokens])

	if (loading) {
		return <></>
	}

	if (!selectedToken.details) {
		return <Redirect to="/profile" />
	}

	return (
		<React.Fragment>
			<div className="content trading-detail-page">
				<Card>
					<CardBody>
						<div className="trading-detail-page__content">
							<div className="img-container">
								<img src={selectedToken.details.uri} alt={"card"} />
								<div className="action-icon">
									<i className="fa fa-info" />
								</div>
							</div>
							<div className="detail-body">
								<div className="card-info">
									<h3 className="title">{selectedToken.details.name}</h3>
									<div>
										<p className="font-size-14 font-weight-semibold mb-0">{formatAddress(selectedToken.wallet)}</p>
										<span>Creator</span>
									</div>
									<p className="mt-2 font-size-15">{selectedToken.details.description}</p>
								</div>
									<div className="buy-card">
										<div className="buy-card__header">
											<div className="title">
												<p className="font-size-16 font-weight-semibold mb-0">Unique collectible</p>
												<span>1 of 1</span>
											</div>
											<p className="font-size-16 font-weight-semibold mb-0">0.3</p>
										</div>
										<Button color="primary" className="btn btn-primary w-100 my-3">
											Buy now
										</Button>
										<div style={{ textAlign: "left" }}>
											<p className="font-size-14 font-weight-semibold mb-0">{formatAddress(selectedToken.wallet)}</p>
											<span>Owner</span>
										</div>
										<div className="divider" />
										<div className="buy-card__menu">
											{selectedToken.source.includes("polygon") &&
												<div className="menu-item">
													<a
														className="card-menu-item"
														href={`https://polygonscan.com/token/${selectedToken.wallet}`}
														target={"_blank"}
														rel="noreferrer"
													>
														View on PolygonScan
													</a>
												</div>
											}
											{selectedToken.source.includes("avalanche") &&
												<div className="menu-item">
													<a
														className="card-menu-item"
														href={`https://cchain.explorer.avax.network/token/${selectedToken.wallet}`}
														target={"_blank"}
														rel="noreferrer"
													>
														View on AvalancheScan
													</a>
												</div>
											}
										</div>
									</div>
							</div>
							<div className="history-table">
								<h3 className="mb-4">History</h3>
								<Table className="align-middle mb-0 table-nowrap">
									<thead className="table-light">
										<tr>
											<th scope="col">Event</th>
											<th scope="col">From</th>
											<th scope="col">To</th>
											<th scope="col">Transaction</th>
											<th scope="col">Date</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Sale Created</td>
											<td>0x059b...b1C5</td>
											<td></td>
											<td></td>
											<td>1 hours ago</td>
										</tr>
										<tr>
											<td>Minted</td>
											<td>0x059b...b1C5</td>
											<td></td>
											<td>
												<Link to="#">0x6573...b1C5</Link>
											</td>
											<td>1 hours ago</td>
										</tr>
									</tbody>
								</Table>
							</div>
						</div>
					</CardBody>
				</Card>
			</div>
		</React.Fragment>
	)
}

const mapStateToProps = (state) => ({
	allTokens: state.commonReducer.allTokens
})

export default connect(mapStateToProps, null)(TradingDetail)
